// extracted by mini-css-extract-plugin
module.exports = {"s1hdzsza":"s1hdzsza"};